
import Swiper from 'swiper';


/*------------------------------
旅館
-------------------------------*/
var slider = new Swiper ('#slider01', {
  slidesPerView: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  loopedSlides: 5,
  centeredSlides : true,
  disableOnInteraction: true,
});

var thumbs = new Swiper('#thumbs01', {
  centeredSlides: true,
  spaceBetween: 25,
  loop: true,
  slidesPerView: "auto",
  touchRatio: 0.2,
  slideToClickedSlide: true,
  navigation: {
    nextEl: '.swiper-next01',
    prevEl: '.swiper-prev01',
  },
  breakpoints: {
    768: {
      spaceBetween: 10,
    }
  }
});

slider.controller.control = thumbs;
thumbs.controller.control = slider;



/*------------------------------
ホテル
-------------------------------*/
var slider2 = new Swiper ('#slider02', {
  slidesPerView: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  loopedSlides: 5,
  centeredSlides : true,
  disableOnInteraction: true,
});

var thumbs2 = new Swiper('#thumbs02', {
  centeredSlides: true,
  spaceBetween: 25,
  loop: true,
  slidesPerView: "auto",
  touchRatio: 0.2,
  slideToClickedSlide: true,
  navigation: {
    nextEl: '.swiper-next02',
    prevEl: '.swiper-prev02',
  },
  breakpoints: {
    768: {
      spaceBetween: 10,
    }
  }
});

slider2.controller.control = thumbs2;
thumbs2.controller.control = slider2;



/*------------------------------
ペンション
-------------------------------*/
var slider3 = new Swiper ('#slider03', {
  slidesPerView: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  loopedSlides: 5,
  centeredSlides : true,
  disableOnInteraction: true,
});

var thumbs3 = new Swiper('#thumbs03', {
  centeredSlides: true,
  spaceBetween: 25,
  loop: true,
  slidesPerView: "auto",
  touchRatio: 0.2,
  slideToClickedSlide: true,
  navigation: {
    nextEl: '.swiper-next03',
    prevEl: '.swiper-prev03',
  },
  breakpoints: {
    768: {
      spaceBetween: 10,
    }
  }
});

slider3.controller.control = thumbs3;
thumbs3.controller.control = slider3;



/*------------------------------
民宿
-------------------------------*/
var slider4 = new Swiper ('#slider04', {
  slidesPerView: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  loopedSlides: 5,
  centeredSlides : true,
  disableOnInteraction: true,
});

var thumbs4 = new Swiper('#thumbs04', {
  centeredSlides: true,
  spaceBetween: 25,
  loop: true,
  slidesPerView: "auto",
  touchRatio: 0.2,
  slideToClickedSlide: true,
  navigation: {
    nextEl: '.swiper-next04',
    prevEl: '.swiper-prev04',
  },
  breakpoints: {
    768: {
      spaceBetween: 10,
    }
  }
});

slider4.controller.control = thumbs4;
thumbs4.controller.control = slider4;



/*------------------------------
貸し別荘
-------------------------------*/
var slider5 = new Swiper ('#slider05', {
  slidesPerView: 1,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  loop: true,
  loopedSlides: 5,
  centeredSlides : true,
  disableOnInteraction: true,
});

var thumbs5 = new Swiper('#thumbs05', {
  centeredSlides: true,
  spaceBetween: 25,
  loop: true,
  slidesPerView: "auto",
  touchRatio: 0.2,
  slideToClickedSlide: true,
  navigation: {
    nextEl: '.swiper-next05',
    prevEl: '.swiper-prev05',
  },
  breakpoints: {
    768: {
      spaceBetween: 10,
    }
  }
});

slider5.controller.control = thumbs5;
thumbs5.controller.control = slider5;